import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React from 'react';
import Divider from '@material-ui/core/Divider';
import { IProductData, enCurrency } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';
import { Locale } from '../Locale';
import Body from './Body';
import Coupon from '../Coupon';
import Collapse from '@material-ui/core/Collapse';
import { IS_ECOMMERCE } from 'settings';
import Translate from 'components/Translate';
import CouponPrice from '../Coupon/CouponPrice';
import { WithStyles } from 'shared/decorators/withStyles';
import { currencyService } from 'services/CurrencyService';
import { CurrencyFormat } from 'components/CurrencyFormat';

interface IState extends IStateBase {
  cart: IProductData;
  currency: enCurrency;
  circle?: boolean;
  payment: ICartModel;
  showDetails: boolean;
  feeInstallment: number;
}

@WithStyles(() => ({
  component: {
    '& .descriptionQuantity': {
      '@media screen and (min-width: 960px)': {
        display: 'none'
      }
    },

    '& .title': {
      '@media screen and (max-width: 600px)': {
        margin: '0 0 8px 0',
        textAlign: 'center'
      },

      margin: '0 0 24px 0',
      fontSize: '1rem'
    },

    '& .nameColumn': {
      color: '#192542',
      fontWeight: 'bold',
      fontSize: '0.785rem',

      '&.right': {
        width: '100%',
        textAlign: 'right'
      },

      '& svg': {
        height: '13px',
        marginRight: '5px'
      }
    },

    '& .coupon_price': {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '12px 0 12px 0',

      '& .chk-coupon .field.normal': {
        '& label': {
          fontSize: '1rem',

          '@media screen and (max-width: 600px)': {
            fontSize: '0.750rem'
          },

          '&[data-shrink="false"], &[data-shrink="true"]': {
            transform: 'translate(0, -8px) scale(1)'
          }
        }
      },

      '&.just_price': {
        justifyContent: 'flex-end'
      },

      '& .price': {
        display: 'flex',
        alignItems: 'flex-end',
        fontSize: '1.225rem',
        fontWeight: 'bold',
        flexDirection: 'column',

        '& .total': {
          fontSize: '0.775rem',
          fontWeight: 'normal',
          margin: '0 4px 2px 0'
        },

        '& .value': {
          marginRight: '5px'
        }
      }
    },

    '& .details': {
      display: 'flex',
      flexDirection: 'column',

      '&.reverse': {
        flexDirection: 'column-reverse'
      },

      '& .showDetails': {
        textAlign: 'center',
        margin: '0 0 18px',
        fontSize: '0.675rem',
        textDecoration: 'underline',
        color: '#596375',

        '@media screen and (min-width: 600px)': {
          display: 'none'
        }
      }
    }
  }
}))
export default class PriceQuantity extends BaseComponent<IState, {}> {
  componentDidMount() {
    const feeObservable = cartService
      .getCart()
      .map(c => c.feeInstallment)
      .distinctUntilChanged();

    this.observeState({ feeInstallment: null }, feeObservable);
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ payment: null }, paymentService.getCart());
    this.observeState({ currency: null }, currencyService.getCurrency());
  }

  setShowDetails = () => {
    this.setState({ showDetails: !this.state.showDetails });
  };

  render() {
    if (!this.state) {
      return null;
    }
    const { cart, showDetails, feeInstallment, currency } = this.state;

    const price = currency === enCurrency.USD ? cart.taxedPrice : cart.price;

    return (
      <div className={this.props.classes.component}>
        <h3 className="title">{cart.content.title}</h3>

        <div className={`details ${this.setShowDetails ? 'reverse' : ''}`}>
          <div className="showDetails" onClick={this.setShowDetails}>
            {showDetails ? <Translate term="Esconder Detalhes" /> : <Translate term="Detalhes do evento" />}
          </div>
          <Collapse in={showDetails}>
            <Locale />
          </Collapse>
        </div>

        {!IS_ECOMMERCE ? (
          <div>
            <Body />
            <Divider />
          </div>
        ) : (
          <div className="descriptionQuantity">
            {cart.products[0].description}
            <Divider />
          </div>
        )}

        <div className={`coupon_price ${!cart.config.hasCoupon ? 'just_price' : ''}`}>
          <Coupon />
          <div className="price theme-label">
            <div>
              <CouponPrice />
            </div>
            <span id="final_price" className="value">
              <CurrencyFormat value={price} />
            </span>
            {feeInstallment === 0 && currency !== enCurrency.USD ? (
              <span className="chk-no-fee">
                <Translate term="SEM JUROS" />
              </span>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    );
  }
}
